if (!customElements.get('klaviyo-form')) {
  class KlaviyoForm extends HTMLElement {
    constructor() {
      super();

      /** @type {HTMLFormElement} */
      // @ts-ignore
      this.form = this.querySelector('form');
    }

    connectedCallback() {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    /**
     * @param {string} message
     */
    showError(message) {
      /** @type {HTMLElement} */
      // @ts-ignore
      const errorEl = this.querySelector('klaviyo-form-error');
      errorEl.innerText = message;
      this.setAttribute('status', 'errors');
    }

    success() {
      this.setAttribute('status', 'submitted');
    }

    /**
     * @param {Record<string, any>} data
     */
    serializeData(data) {
      const formData = [];
      for (let key in data) {
        if (data.hasOwnProperty(key)) {
          const value = data[key];
          formData.push(`${key}=${encodeURIComponent(value)}`);
        }
      }
      return formData.join('&');
    }

    /**
     * @param {Event} event
     */
    async onSubmit(event) {
      event.preventDefault();

      // @ts-ignore
      const email = this.form.querySelector('input[type="email"]').value;
      const listId = this.dataset.listId;
      const source = this.dataset.source;
      const subscribeUrl =
        'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';

      const fields = {
        $source: source,
      };

      const data = {
        g: listId,
        $fields: Object.keys(fields),
        email: email,
        ...fields,
      };

      try {
        const response = await fetch(subscribeUrl, {
          method: 'POST',
          headers: {
            'cache-control': 'no-cache',
            'content-type': 'application/x-www-form-urlencoded',
          },
          body: this.serializeData(data),
        });

        const result = await response.json();

        if (result.success === false) {
          this.showError('Error subscribing to list');
          return;
        }

        if (result.success === true) {
          this.success();
        }
      } catch (error) {
        console.error(
          '%cKlaviyoForm: Error',
          'color:orangered;font-weight:bold',
          error,
        );
        this.showError('Something went wrong, could not subscribe');
      }
    }
  }

  customElements.define('klaviyo-form', KlaviyoForm);
}
